"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var FontAwesome_1 = require("../../../../../../shared/components/icons/FontAwesome");
var PlayerLevelAttributesList_1 = require("./cfg_attributes/PlayerLevelAttributesList");
var PlayerLevelAttributeEditor_1 = require("./cfg_attributes/PlayerLevelAttributeEditor");
var PlayerLevelLocalesList_1 = require("./cfg_locales/PlayerLevelLocalesList");
var PlayerLevelLocalesEditor_1 = require("./cfg_locales/PlayerLevelLocalesEditor");
var PlayerLevelBetAmountsList_1 = require("./cfg_betamounts/PlayerLevelBetAmountsList");
var PlayerLevelBetAmountsEditor_1 = require("./cfg_betamounts/PlayerLevelBetAmountsEditor");
var PlayerLevelOffersList_1 = require("./cfg_offers/PlayerLevelOffersList");
var PlayerLevelOffersEditor_1 = require("./cfg_offers/PlayerLevelOffersEditor");
var PlayerLevelConfig = /** @class */ (function (_super) {
    __extends(PlayerLevelConfig, _super);
    function PlayerLevelConfig(props) {
        var _this = _super.call(this, props) || this;
        _this.tab_lvl_attribute = "lvl.attribute";
        _this.tab_lvl_titles = "lvl.titles";
        _this.tab_lvl_betamounts = "lvl.betamounts";
        _this.tab_lvl_offers = "lvl.offers";
        return _this;
    }
    PlayerLevelConfig.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_AL = this.props.listAvailAppLanguages.Subscribe("*", function (id, data) {
            _this.setState({ avail_languages: data.data });
        });
        this.SID_AC = this.props.listAvailAppCurrency.Subscribe("*", function (id, data) {
            _this.setState({ avail_currency: data.data });
        });
        this.setState({
            LVLAttributeMode: "LIST",
            LVLLocaleMode: "LIST",
            LVLBetAmtMode: "LIST",
            LVLOfferMode: "LIST",
            LVLAttributeRecord: null,
            LVLLocaleRecord: null,
            LVLBetAmtRecord: null,
            LVLOfferRecord: null,
            attribute_page_size: this.props.state.UITablePageSize,
            locale_page_size: this.props.state.UITablePageSize,
            betamt_page_size: this.props.state.UITablePageSize,
            offer_page_size: this.props.state.UITablePageSize,
            attribute_page_num: 1,
            locale_page_num: 1,
            betamt_page_num: 1,
            offer_page_num: 1,
            avail_languages: [],
            avail_currency: []
        }, function () {
            _this.props.listAvailAppLanguages.LoadData();
            _this.props.listAvailAppCurrency.LoadData();
        });
        this.props.state.setExtBreadCrumbPath(["\u041F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u044B \u0443\u0440\u043E\u0432\u043D\u044F - [" + this.props.record.title + "]"]);
    };
    PlayerLevelConfig.prototype.componentWillUnmount = function () {
        this.props.listAvailAppLanguages.UnSubscribe(this.SID_AL);
        this.props.listAvailAppCurrency.UnSubscribe(this.SID_AC);
    };
    PlayerLevelConfig.prototype.backToRootClick = function () {
        if (this.props.onGoBackClick) {
            this.props.onGoBackClick();
        }
    };
    PlayerLevelConfig.prototype.newLevelBetAmountClick = function () {
        this.setState({ LVLBetAmtMode: "NEW", LVLBetAmtRecord: null });
    };
    PlayerLevelConfig.prototype.editLevelBetAmountClick = function (record) {
        this.setState({ LVLBetAmtMode: "EDIT", LVLBetAmtRecord: record });
    };
    PlayerLevelConfig.prototype.backToLevelBetAmountListClick = function () {
        this.setState({ LVLBetAmtMode: "LIST", LVLBetAmtRecord: null });
    };
    PlayerLevelConfig.prototype.onLevelBetAmountPageConfigChange = function (PageNum, PageSize) {
        this.setState({ betamt_page_num: PageNum, betamt_page_size: PageSize });
    };
    PlayerLevelConfig.prototype.getLevelBetAmountObject = function () {
        if (this.state.LVLBetAmtMode === "LIST") {
            return (React.createElement(PlayerLevelBetAmountsList_1.default, { state: this.props.state, data: this.props.dataLvlBetAmounts, onGoBack: this.backToRootClick.bind(this), onNewClick: this.newLevelBetAmountClick.bind(this), onEditClick: this.editLevelBetAmountClick.bind(this), rootRecord: this.props.record, onPageConfigChanged: this.onLevelBetAmountPageConfigChange.bind(this), pageNum: this.state.betamt_page_num, pageSize: this.state.betamt_page_size }));
        }
        if (this.state.LVLBetAmtMode === "NEW") {
            return (React.createElement(PlayerLevelBetAmountsEditor_1.default, { data: this.props.dataLvlBetAmounts, record: null, rootRecord: this.props.record, state: this.props.state, onGoBack: this.backToLevelBetAmountListClick.bind(this), availCurrency: this.state.avail_currency }));
        }
        if (this.state.LVLBetAmtMode === "EDIT") {
            return (React.createElement(PlayerLevelBetAmountsEditor_1.default, { data: this.props.dataLvlBetAmounts, record: this.state.LVLBetAmtRecord, rootRecord: this.props.record, state: this.props.state, onGoBack: this.backToLevelBetAmountListClick.bind(this), availCurrency: this.state.avail_currency }));
        }
        throw "No available render for active edit mode -> " + this.state.LVLBetAmtMode;
    };
    PlayerLevelConfig.prototype.newLevelAttributeClick = function () {
        this.setState({ LVLAttributeMode: "NEW", LVLAttributeRecord: null });
    };
    PlayerLevelConfig.prototype.editLevelAttributeClick = function (record) {
        this.setState({ LVLAttributeMode: "EDIT", LVLAttributeRecord: record });
    };
    PlayerLevelConfig.prototype.backToLevelAttributesListClick = function () {
        this.setState({ LVLAttributeMode: "LIST", LVLAttributeRecord: null });
    };
    PlayerLevelConfig.prototype.onLevelAttributesPageConfigChange = function (PageNum, PageSize) {
        this.setState({ attribute_page_num: PageNum, attribute_page_size: PageSize });
    };
    PlayerLevelConfig.prototype.getLevelAttributeObject = function () {
        if (this.state.LVLAttributeMode === "LIST") {
            return (React.createElement(PlayerLevelAttributesList_1.default, { state: this.props.state, data: this.props.dataLvlAttributes, onGoBack: this.backToRootClick.bind(this), onNewClick: this.newLevelAttributeClick.bind(this), onEditClick: this.editLevelAttributeClick.bind(this), rootRecord: this.props.record, onPageConfigChanged: this.onLevelAttributesPageConfigChange.bind(this), pageNum: this.state.attribute_page_num, pageSize: this.state.attribute_page_size }));
        }
        if (this.state.LVLAttributeMode === "NEW") {
            return (React.createElement(PlayerLevelAttributeEditor_1.default, { data: this.props.dataLvlAttributes, record: null, rootRecord: this.props.record, state: this.props.state, onGoBack: this.backToLevelAttributesListClick.bind(this), availLanguages: this.state.avail_languages, availCurrency: this.state.avail_currency }));
        }
        if (this.state.LVLAttributeMode === "EDIT") {
            return (React.createElement(PlayerLevelAttributeEditor_1.default, { data: this.props.dataLvlAttributes, record: this.state.LVLAttributeRecord, rootRecord: this.props.record, state: this.props.state, onGoBack: this.backToLevelAttributesListClick.bind(this), availLanguages: this.state.avail_languages, availCurrency: this.state.avail_currency }));
        }
        throw "No available render for active edit mode -> " + this.state.LVLAttributeMode;
    };
    PlayerLevelConfig.prototype.newLevelLocaleClick = function () {
        this.setState({ LVLLocaleMode: "NEW", LVLLocaleRecord: null });
    };
    PlayerLevelConfig.prototype.editLevelLocaleClick = function (record) {
        this.setState({ LVLLocaleMode: "EDIT", LVLLocaleRecord: record });
    };
    PlayerLevelConfig.prototype.backToLevelLocalesListClick = function () {
        this.setState({ LVLLocaleMode: "LIST", LVLLocaleRecord: null });
    };
    PlayerLevelConfig.prototype.onLevelLocalePageConfigChange = function (PageNum, PageSize) {
        this.setState({ locale_page_num: PageNum, locale_page_size: PageSize });
    };
    PlayerLevelConfig.prototype.getLevelLocaleObject = function () {
        if (this.state.LVLLocaleMode === "LIST") {
            return (React.createElement(PlayerLevelLocalesList_1.default, { state: this.props.state, data: this.props.dataLvlLocales, onGoBack: this.backToRootClick.bind(this), onNewClick: this.newLevelLocaleClick.bind(this), onEditClick: this.editLevelLocaleClick.bind(this), rootRecord: this.props.record, onPageConfigChanged: this.onLevelLocalePageConfigChange.bind(this), pageNum: this.state.locale_page_num, pageSize: this.state.locale_page_size }));
        }
        if (this.state.LVLLocaleMode === "EDIT") {
            return (React.createElement(PlayerLevelLocalesEditor_1.default, { data: this.props.dataLvlLocales, availLanguages: this.state.avail_languages, record: this.state.LVLLocaleRecord, rootRecord: this.props.record, state: this.props.state, onGoBack: this.backToLevelLocalesListClick.bind(this) }));
        }
        if (this.state.LVLLocaleMode === "NEW") {
            return (React.createElement(PlayerLevelLocalesEditor_1.default, { data: this.props.dataLvlLocales, availLanguages: this.state.avail_languages, record: null, rootRecord: this.props.record, state: this.props.state, onGoBack: this.backToLevelLocalesListClick.bind(this) }));
        }
        throw "No available render for active edit mode -> " + this.state.LVLLocaleMode;
    };
    PlayerLevelConfig.prototype.newLevelOfferClick = function () {
        this.setState({ LVLOfferMode: "NEW", LVLOfferRecord: null });
    };
    PlayerLevelConfig.prototype.editLevelOfferClick = function (record) {
        this.setState({ LVLOfferMode: "EDIT", LVLOfferRecord: record });
    };
    PlayerLevelConfig.prototype.backToLevelOffersListClick = function () {
        this.setState({ LVLOfferMode: "LIST", LVLOfferRecord: null });
    };
    PlayerLevelConfig.prototype.onLevelOfferPageConfigChange = function (PageNum, PageSize) {
        this.setState({ offer_page_num: PageNum, offer_page_size: PageSize });
    };
    PlayerLevelConfig.prototype.getLevelOfferObject = function () {
        if (this.state.LVLOfferMode === "LIST") {
            return (React.createElement(PlayerLevelOffersList_1.default, { state: this.props.state, data: this.props.dataLvlOffers, onGoBack: this.backToRootClick.bind(this), onNewClick: this.newLevelOfferClick.bind(this), onEditClick: this.editLevelOfferClick.bind(this), rootRecord: this.props.record, onPageConfigChanged: this.onLevelOfferPageConfigChange.bind(this), pageNum: this.state.locale_page_num, pageSize: this.state.locale_page_size }));
        }
        if (this.state.LVLOfferMode === "EDIT") {
            return (React.createElement(PlayerLevelOffersEditor_1.default, { data: this.props.dataLvlOffers, availLanguages: this.state.avail_languages, record: this.state.LVLOfferRecord, rootRecord: this.props.record, state: this.props.state, onGoBack: this.backToLevelOffersListClick.bind(this) }));
        }
        if (this.state.LVLOfferMode === "NEW") {
            return (React.createElement(PlayerLevelOffersEditor_1.default, { data: this.props.dataLvlOffers, availLanguages: this.state.avail_languages, record: null, rootRecord: this.props.record, state: this.props.state, onGoBack: this.backToLevelOffersListClick.bind(this) }));
        }
        throw "No available render for active edit mode -> " + this.state.LVLOfferMode;
    };
    PlayerLevelConfig.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement(antd_1.Tabs, { defaultActiveKey: this.tab_lvl_titles },
                React.createElement(antd_1.Tabs.TabPane, { tab: React.createElement("span", { style: { width: 200, minWidth: 200 } },
                        React.createElement(FontAwesome_1.FA, { left: true, icon: "font" }),
                        "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u044F"), key: this.tab_lvl_titles }, this.getLevelLocaleObject()),
                React.createElement(antd_1.Tabs.TabPane, { tab: React.createElement("span", { style: { width: 200, minWidth: 200 } },
                        React.createElement(FontAwesome_1.FA, { left: true, icon: "tags" }),
                        "\u0410\u0442\u0442\u0440\u0438\u0431\u0443\u0442\u044B"), key: this.tab_lvl_attribute }, this.getLevelAttributeObject()),
                React.createElement(antd_1.Tabs.TabPane, { tab: React.createElement("span", { style: { width: 200, minWidth: 200 } },
                        React.createElement(FontAwesome_1.FA, { left: true, icon: "coins" }),
                        "\u0421\u0442\u0430\u0432\u043A\u0438"), key: this.tab_lvl_betamounts }, this.getLevelBetAmountObject()),
                React.createElement(antd_1.Tabs.TabPane, { tab: React.createElement("span", { style: { width: 200, minWidth: 200 } },
                        React.createElement(FontAwesome_1.FA, { left: true, icon: "gifts" }),
                        "\u041E\u0444\u0444\u0435\u0440\u044B"), key: this.tab_lvl_offers }, this.getLevelOfferObject()))));
    };
    return PlayerLevelConfig;
}(React.Component));
exports.default = PlayerLevelConfig;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_player_levels/ui/component/PlayerLevelConfig.tsx
// module id = 1949
// module chunks = 0